import cx from 'classnames';
import React, { useState, useCallback } from 'react';
import { useLifecycles } from 'react-use';

import './auto-height-iframe.scss';

interface Props {
    src: string | null;
    className?: string;
    origins: string[];
    defaultHeight?: number;
}

export const AutoHeightIframe = React.memo(({ src, className, origins, defaultHeight }: Props) => {
    const [height, setHeight] = useState();

    const receiveMessage = useCallback(
        (event: MessageEvent) => {
            if (origins.includes(event.origin) && event.data.height) {
                setHeight(event.data.height);
            }
        },
        [origins, setHeight]
    );

    useLifecycles(
        () => {
            if (!isSSR) {
                window.addEventListener('message', receiveMessage, false);
            }
        },
        () => {
            if (!isSSR) {
                window.removeEventListener('message', receiveMessage, false);
            }
        }
    );

    if (!src) {
        return null;
    }

    return (
        <iframe
            className={cx('auto-height-iframe', className)}
            frameBorder="0"
            height={height || defaultHeight}
            src={src}
        />
    );
});
